import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DeliveryContainerTileContentProps } from './delivery-container-tile-content.component';

export const useDeliveryContainerTileContentStyles = makeStyles<Theme, DeliveryContainerTileContentProps>({
  root: {
    height: '100%',
    width: '100%'
  },
  icon: {
    width: '24px',
    color: '#6F6F6F'
  },
  deliveryContainer: {
    gap: '4px'
  },
  deliveryContainerName: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#000',
    marginBottom: 0
  },
  reserveeChipsContainer: {
    position: 'absolute',
    bottom: (props) => (props.reserveeChipVerticalPosition === 'bottom' ? '6px' : '50%'),
    transform: (props) => (props.reserveeChipVerticalPosition === 'center' ? 'translateY(50%)' : 'none'),
    right: '2px',
    display: 'flex',
    gap: '4px'
  },
  rightIconContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '4px'
  },
  rightIconWrapper: {
    display: 'inline-flex'
  },
  rightIcon: {
    maxWidth: '20px',
    maxHeight: '20px',
    color: '#6F6F6F'
  }
});
